<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-card-title>品牌故事管理</v-card-title>
        <v-card-text>
          <v-layout v-for="col in getDialogKeys" :key="col.value">
            <v-flex>
              <br/><span class="title" v-if="col.editorOption">{{col.editorOption.placeholder}}</span><br/>
              <quill-editor v-if="col.value === 'content' || col.value === 'storeContent' || col.value === 'history'"
                            class="mb-2 mt-2"
                            ref="myQuillEditor"
                            v-model="itemDetail[col.value]"
                            :options="col.editorOption"
                            @blur="onEditorBlur($event)"
                            @focus="onEditorFocus($event)"
                            @ready="onEditorReady($event)"
              />
              <v-text-field v-else v-model="itemDetail[col.value]"
                            :label="col.text"
                            :color="Theme.GREEN"></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn dark :color="Theme.GREEN" :loading="saveLoading" @click="saveData">確定</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import common from "@/mixins/common";
import {mapActions} from 'vuex';

export default {
name: "about",
  mixins: [common],
  data(){
    return {
      itemDetail: {
        aboutId: '',
        title:'',
        content:'',
        storeContent:'',
        history:'',
      },
      saveLoading: false,
    }
  },
  created() {
    this.loadData();
  },
  mounted() {
    console.log('this is current quill instance object', this.editor)
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill
    },
    getDialogKeys() {
      return [
        {value: 'title', text: '標題'},
        {value: 'content', text: '品牌故事', editorOption: {
            placeholder:'品牌故事'
          },},
        {value: 'storeContent', text: '通路介紹', editorOption: {
            placeholder:'通路介紹'
          },},
        {value: 'history', text: '歷史', editorOption: {
            placeholder:'歷史'
          },},
      ];
    },
  },
  methods: {
    ...mapActions(['getAboutInfo', 'saveAboutInfo']),
    onEditorBlur(quill) {
      console.log('editor blur!', quill)
    },
    onEditorFocus(quill) {
      console.log('editor focus!', quill)
    },
    onEditorReady(quill) {
      console.log('editor ready!', quill);
      quill.container.style.height = '500px';
    },
    onEditorChange({ quill, html, text }) {
      console.log('editor change!', quill, html, text)
      this.content = html
    },
    async loadData(){
      this.loading = true;
      const res = await this.getAboutInfo({});

      if (res.data.code === 0){
        this.itemDetail = res.data.body;

        console.log(`getAboutInfo ${JSON.stringify(res.data.body)}`);
      }
      this.loading = false;
    },
    async saveData(){
      this.saveLoading = true;

      console.log(`save ${JSON.stringify(this.itemDetail)}`);
      const res = await this.saveAboutInfo({token: '', info: this.itemDetail});
      const result = res.data;
      if (result.code === 0) {
        this.showMessageDialog('成功', '儲存成功');
      } else {
        this.showMessageDialog('錯誤', result.message ? result.message : '儲存失敗');
      }
      this.saveLoading = false;
    },
    showMessageDialog(title, content) {
      console.log(`showAlert ${title} ${content}`);
      this.showAlert({
        title: title,
        content: content,
        showCancel: false,
        confirmEvent: async () => {
          this.hideAlert();
        }
      });
    },
  }
}
</script>

<style scoped>

</style>
